import {Injectable} from "@angular/core";
import {ModelFactory} from "@shared/factories/model.factory";
import {ExtraJob} from "@modules/extra-job/models/extra-job.model";
import {Job} from "@modules/job/models/job.model";
import {OrderData, OrderSummary} from "@shared/component/payments/components/order-summary/order-summary.type";

@Injectable({
  providedIn: 'root'
})
export class OrderSummaryFactory extends ModelFactory<OrderData, OrderSummary> {
  create(state: OrderData): OrderSummary {
    if (state instanceof ExtraJob) {
      return this.createExtraJobOrderSummary(state);
    }

    return this.createJobOrderSummary(state);
  }

  private createExtraJobOrderSummary(state: ExtraJob): OrderSummary {
    return new OrderSummary(
      state,
      state.currency,
      this.resolveExtraJobSupportedCountry(state),
      state.officialFee,
      state.subTotalAmount,
      state.vatAmount,
      state.totalAmount,
    );
  }

  private createJobOrderSummary(state: Job): OrderSummary {
    const order = state.order;
    const jobFee = state.fee;

    return new OrderSummary(
      state,
      order?.currency ?? jobFee.supportedCountry.currency,
      jobFee.supportedCountry,
      jobFee.officialFee,
      order?.subtotal ?? jobFee.subtotal,
      jobFee.tax,
      order?.totalAmount ?? jobFee.total,
      jobFee.supportedCountry.taxRate,
    );
  }

  private resolveExtraJobSupportedCountry(state: ExtraJob) {
    const orderable = state.order?.orderable;

    if (state.job?.supportedCountry) {
      return state.job.supportedCountry;
    }

    if (orderable instanceof Job) {
      return orderable.supportedCountry;
    }

    if (orderable instanceof ExtraJob) {
      return orderable.job?.supportedCountry ?? null;
    }

    if (orderable && 'job' in orderable) {
      return (orderable as { job?: Job }).job?.supportedCountry ?? null;
    }

    return null;
  }
}
